import { ListScreen, StackScreenProps } from '@rahtab/stack-navigator';
import { Button, getSpacing, ListEmpty, TextView } from '@rahtab/ui';
import StockHostoryIcon from '@rahtab/ui/dist/icons/ListEmptyIcons/StockHistory';
import { useStockList } from 'hooks/InventoryHooks/useStockList';
import { useAppDispatch, useSelector } from 'rahtab-redux';
import { setLoading } from 'rahtab-redux/slices/stockListSlice';
import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { RootStackType } from '../../../Router';
import StockListItem from './StockListItem';

const StockList: React.VFC<StockListProps> = ({ route, navigation }) => {
  const { navigate } = navigation;
  const { assignFinalCode } = route.params;
  const { loading: sliceLoading } = useSelector((state) => state.stockList);
  const dispatch = useAppDispatch();
  const { called, data, loading, refetch } = useStockList(assignFinalCode);
  // const isSubmitBtnEnabled = load.data?.statusCode === '4';
  useEffect(() => {
    if (sliceLoading === 'refreshing') {
      refetch();
      dispatch(setLoading('idle'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sliceLoading]);
  return (
    <ListScreen
      title="عرضه بار در فروشگاه"
      loading={loading}
      refreshing={called && loading}
      onRefresh={refetch}
      renderControls={() => {
        return (
          <View style={styles.controlContainer}>
            <TextView
              isSpaceBetween
              style={styles.stockCountTextView}
              title="تعداد عرضه‌ها"
              value={data?.length}
              marginBottom={0}
            />
            <Button
              style={styles.newStockButton}
              text="ثبت عرضه جدید بار"
              color="primary"
              // disabled={!isSubmitBtnEnabled}
              onPress={() => navigate('NewStock', { assignFinalCode })}
            />
          </View>
        );
      }}
      listData={data}
      ListEmptyComponent={<ListEmpty text="سابقه عرضه بار وجود ندارد." imageComponent={<StockHostoryIcon />} />}
      keyExtractor={(_, index) => `StockList-${index}`}
      renderItem={({ item }) => {
        const {
          stockCode,
          saleAmount,
          statusText,
          status,
          stockAmount,
          stockDate,
          salePercent,
          stockPrice,
          stopReason,
          stopDate,
          unitText,
        } = item;
        return (
          <StockListItem
            salePercent={salePercent}
            stockAmount={stockAmount}
            stockDate={stockDate}
            unitText={unitText}
            assignFinalCode={assignFinalCode}
            stockCode={stockCode}
            stockPrice={stockPrice}
            saleAmount={saleAmount}
            statusText={statusText}
            status={status}
            stopReason={stopReason}
            stopDate={stopDate}
          />
        );
      }}
    />
  );
};

export default StockList;

const styles = StyleSheet.create({
  controlContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  stockCountTextView: {
    flex: 1,
    marginRight: getSpacing(),
  },
  newStockButton: {
    flex: 2,
  },
});

type StockListProps = StackScreenProps<RootStackType, 'StockList'>;
